<template>
	<div>
		<a
			class="dropdown-toggle"
			:class="classLabel"
			data-bs-toggle="dropdown"
			href="#"
			role="button"
			aria-haspopup="false"
			aria-expanded="false"
			@click.stop.prevent="toggle"
			@mouseenter="onMouseEnter"
			ref="dropdownToggle"
		>
			<slot name="label"></slot>
		</a>
		<div
			class="
				dropdown-menu dropdown-menu-end dropdown-menu-animated
				topbar-dropdown-menu
				show
			"
			:class="classMenu"
			v-if="isOpen"
			:style="dropdownStyle"
			v-click-outside="toggle"
		>
			<slot name="menu"></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		classLabel: {
			type: String,
			default: '',
		},
		classMenu: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		isOpen: false,
		isOverElement: false,
	}),
	created() {
		window.addEventListener('click', this.handleClick);
	},
	destroyed() {
		window.removeEventListener('click', this.handleClick);
	},
	methods: {
		toggle() {
			this.isOpen = !this.isOpen;
		},
		handleClick() {
			if (!this.isOverElement && this.isOpen) {
				this.isOpen = false;
			}
		},
		onMouseEnter() {
			this.isOverElement = true;
		},
		onBodyClick() {
			this.isOverElement = true;
		},
	},
	computed: {
		dropdownStyle() {
			const rect = this.$refs.dropdownToggle.getBoundingClientRect();
			// eslint-disable-next-line no-restricted-globals
			const screenWidth = screen.width;
			const bottom = rect.bottom + 2;
			const right = screenWidth - rect.right;
			return {
				position: 'absolute',
				inset: '0px auto auto 0px',
				margin: '0px',
				transform: `translate3d(-${right}px, ${bottom}px, 0px)`,
			};
		},
	},
};
</script>
